"use strict";

(function () {
  if (!customElements.get("sticky-atc-bar")) {
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.parent = this.closest(".sticky-add-to-cart");
        this.variantSelects = this.querySelectorAll(".sticky-atc-bar__variant-select");
        this.submitButton = this.querySelector(".sticky-atc-bar__submit");
        this.productImage = this.querySelector(".sticky-atc-bar__media img");
        this.priceContainers = this.querySelectorAll(".sticky-atc-bar__price");
        this.titleElement = this.querySelector(".sticky-atc-bar__title");
        this.variantIdInput = this.querySelector('input[name="id"]');
        this.previousButtonText = null;
      }

      connectedCallback() {
        if (this.submitButton) {
          const buttonText = this.submitButton.querySelector(".sticky-atc-bar__button-text");
          if (buttonText && !this.previousButtonText) {
            this.previousButtonText = buttonText.textContent;
          }
        }
        
        this.initializeVariantSync();
        this.attachEventListeners();
        this.setStickyBarHeight();
        this.initializeFormHandling();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      initializeVariantSync() {
        this.syncWithMainProduct();
        
        this.variantSelects.forEach(select => {
          select.addEventListener("change", (e) => {
            this.handleVariantChange(e);
          });
        });

      }

      syncWithMainProduct() {
        const mainVariantPicker = document.querySelector(".variant-picker");
        if (!mainVariantPicker) return;

        document.addEventListener("variant:change", (e) => {
          this.updateFromMainProduct(e.detail);
        });

        document.addEventListener("variant:selected", (e) => {
          this.updateFromMainProduct(e.detail);
        });

        document.addEventListener("variant:unavailable", (e) => {
          if (this.submitButton) {
            const buttonText = this.submitButton.querySelector(".sticky-atc-bar__button-text");
            this.submitButton.setAttribute("disabled", "disabled");
            if (buttonText) {
              const unavailable =
                this.submitButton.dataset.unavailableText ||
                window.variantStrings?.unavailable ||
                "Unavailable";
              buttonText.textContent = unavailable;
              this.previousButtonText = buttonText.textContent;
            }
          }
          this.priceContainers.forEach(c => c.classList.add('hidden'));
          this.showVariantOverlays();
        });

        const mainSelects = mainVariantPicker.querySelectorAll("select[name*='options']");
        const mainInputs = mainVariantPicker.querySelectorAll("input[name*='options']");
        const radioInputs = mainVariantPicker.querySelectorAll("input[type='radio'][name*='-']");
        
        [...mainSelects, ...mainInputs, ...radioInputs].forEach(mainInput => {
          mainInput.addEventListener("change", (e) => {
            this.syncFromMainInput(e.target);
          });
        });
      }

      showVariantOverlays() {
        const noneText =
          (this.submitButton && this.submitButton.dataset.noneText) ||
          window.variantStrings?.none ||
          "None";

        this.querySelectorAll('.sticky-atc-bar__variant').forEach(variant => {
          let overlay = variant.querySelector('.sticky-atc-bar__variant-overlay');
          if (!overlay) {
            overlay = document.createElement('span');
            overlay.className = 'sticky-atc-bar__variant-overlay';
            variant.appendChild(overlay);
          }
          overlay.textContent = noneText;
          overlay.classList.remove('hidden');
        });
      }

      showVariantOverlaysPending() {
        this.querySelectorAll('.sticky-atc-bar__variant').forEach(variant => {
          let overlay = variant.querySelector('.sticky-atc-bar__variant-overlay');
          const label = variant.querySelector('.sticky-atc-bar__variant-label');
          const select = variant.querySelector('.sticky-atc-bar__variant-select');
          const labelText = label ? label.textContent.replace(/:\s*$/, '').trim() : '';
          const valueText =
            select && select.selectedOptions.length
              ? select.selectedOptions[0].textContent.trim()
              : '';
          const displayText =
            [labelText, valueText].filter(Boolean).join(': ') || labelText || valueText || '\u00A0';

          if (!overlay) {
            overlay = document.createElement('span');
            overlay.className = 'sticky-atc-bar__variant-overlay';
            variant.appendChild(overlay);
          }
          overlay.textContent = displayText;
          overlay.classList.remove('hidden');
        });
      }

      hideVariantOverlays() {
        this.querySelectorAll('.sticky-atc-bar__variant-overlay').forEach(overlay => {
          overlay.classList.add('hidden');
        });
      }

      handleVariantChange(event) {
        const changedSelect = event.target;
        const optionPosition = changedSelect.dataset.optionPosition;

        if (changedSelect.name === 'id') {
          this.handleDefaultVariantChange(changedSelect);
          return;
        }
        
        const success = this.updateMainProductVariant(changedSelect, optionPosition);
        
        if (!success) {
          this.updateMainProductViaAPI(changedSelect, optionPosition);
        }
        
        this.syncVariantIdFromMainProduct();
        
        this.updateStickyBarContent();
      }

      handleDefaultVariantChange(select) {
        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        const variantId = select.value;
        const isAvailable = selectedOption.dataset.available === 'true';
        const price = selectedOption.dataset.price;
        const compareAtPrice = selectedOption.dataset.compareAtPrice;
        const media = selectedOption.dataset.media;

        if (this.variantIdInput) {
          this.variantIdInput.value = variantId;
          this.variantIdInput.disabled = !isAvailable;
        }

        if (media && this.productImage) {
          this.productImage.src = media;
        }

        this.priceContainers.forEach(container => {
          const regularPriceEl = container.querySelector('.price__regular .price-item--regular');
          const compareAtPriceEl = container.querySelector('.price__sale .price-item--regular');
          const salePriceEl = container.querySelector('.price__sale .price-item--sale');
          const priceWrapper = container.querySelector('.price');

          if (regularPriceEl && price) regularPriceEl.textContent = price;
          if (compareAtPriceEl) {
            const valueToSet = compareAtPrice || price;
            if (valueToSet) {
              const strike = compareAtPriceEl.querySelector('s.price-item__original');
              if (strike) {
                strike.textContent = valueToSet;
              } else {
                compareAtPriceEl.textContent = '';
                const s = document.createElement('s');
                s.className = 'price-item__original';
                s.textContent = valueToSet;
                compareAtPriceEl.appendChild(s);
              }
            }
          }
          if (salePriceEl && price) salePriceEl.textContent = price;

          if (priceWrapper) {
            priceWrapper.classList.toggle('price--on-sale', !!compareAtPrice);
            priceWrapper.classList.toggle('price--sold-out', !isAvailable);
          }
        });

        if (this.submitButton) {
          const buttonText = this.submitButton.querySelector('.sticky-atc-bar__button-text');
          if (isAvailable) {
            this.submitButton.removeAttribute('disabled');
            if (buttonText) {
              buttonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
            }
          } else {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (buttonText) {
              buttonText.textContent = window.variantStrings?.soldOut || 'Sold out';
            }
          }
        }
      }

      syncVariantIdFromMainProduct() {
        const mainProductForm = document.querySelector('.main-product__details form, .product-form form');
        if (mainProductForm && this.variantIdInput) {
          const mainVariantInput = mainProductForm.querySelector('input[name="id"]');
          if (mainVariantInput && mainVariantInput.value) {
            this.variantIdInput.value = mainVariantInput.value;
            this.variantIdInput.disabled = false;
          }
        }
      }

      updateFromMainProduct(data) {
        let variant;
        let hasVariantData = false;
        
        if (data && typeof data === 'object' && 'variant' in data) {
          variant = data.variant;
          hasVariantData = true;
        } else if (data && typeof data === 'object' && (data.id || data.available !== undefined)) {
          variant = data;
          hasVariantData = true;
        } else if (data && typeof data === 'object' && data.selectedOptionValues) {
          variant = null;
          hasVariantData = false;
        } else {
          variant = data;
          hasVariantData = variant && (variant.id || variant.available !== undefined);
        }

        if (data && typeof data === 'object' && data.selectedOptionValues) {
          this.updateVariantSelectsFromOptions(data.selectedOptionValues);
        } else if (variant && variant.options) {
          this.updateVariantSelectsFromVariant(variant);
        }

        const isPendingVariantResolution =
          data &&
          typeof data === 'object' &&
          Object.prototype.hasOwnProperty.call(data, 'selectedOptionValues') &&
          !Object.prototype.hasOwnProperty.call(data, 'variant');

        if (variant && variant.featured_image && this.productImage) {
          this.productImage.src = variant.featured_image.src;
          this.productImage.alt = variant.featured_image.alt || "";
        }

        if (this.priceContainers && this.priceContainers.length > 0) {
          if (!variant || variant === null) {
            this.priceContainers.forEach(c => c.classList.add('hidden'));
            if (isPendingVariantResolution) {
              this.showVariantOverlaysPending();
            } else {
              this.showVariantOverlays();
            }
          } else {
            this.priceContainers.forEach(c => c.classList.remove('hidden'));
            this.hideVariantOverlays();
            
            if (data && data.html) {
              const html = data.html;
              const stickyBarInHtml = html.querySelector('sticky-atc-bar');
              
              if (stickyBarInHtml) {
                const newPriceContainers = stickyBarInHtml.querySelectorAll('.sticky-atc-bar__price');
                
                this.priceContainers.forEach((container, index) => {
                  const newContainer = newPriceContainers[index];
                  if (newContainer) {
                    container.innerHTML = newContainer.innerHTML;
                  }
                });
              } else {
                const sectionId = data.sectionId;
                const priceElement = html.getElementById(`price-${sectionId}`);
                if (priceElement) {
                  const priceContainer = priceElement.querySelector('.price__container');
                  if (priceContainer) {
                    this.priceContainers.forEach(container => {
                      const existingPrice = container.querySelector('.price');
                      if (existingPrice) {
                        existingPrice.innerHTML = priceElement.innerHTML;
                      }
                    });
                  }
                } else if (typeof window.renderPrice === "function") {
                  this.priceContainers.forEach(container => {
                    window.renderPrice(container, variant);
                  });
                } else {
                  this.priceContainers.forEach(container => {
                    this.updatePriceDisplay(container, variant);
                  });
                }
              }
            } else if (variant.price && !isNaN(variant.price)) {
              this.priceContainers.forEach(container => {
                if (typeof window.renderPrice === "function") {
                  window.renderPrice(container, variant);
                } else {
                  this.updatePriceDisplay(container, variant);
                }
              });
            }
          }
        }

        if (this.submitButton) {
          const buttonText = this.submitButton.querySelector(".sticky-atc-bar__button-text");
          
          if (!this.previousButtonText && buttonText) {
            this.previousButtonText = buttonText.textContent;
          }
          
          if (hasVariantData) {
            if (!variant || variant === null) {
              this.submitButton.setAttribute("disabled", "disabled");
              if (buttonText) {
                buttonText.textContent = window.variantStrings?.unavailable || "Unavailable";
                this.previousButtonText = buttonText.textContent;
              }
            } else if (variant.available) {
              this.submitButton.removeAttribute("disabled");
              if (buttonText) {
                buttonText.textContent = window.variantStrings?.addToCart || "Add to cart";
                this.previousButtonText = buttonText.textContent;
              }
            } else {
              this.submitButton.setAttribute("disabled", "disabled");
              if (buttonText) {
                buttonText.textContent = window.variantStrings?.soldOut || "Sold out";
                this.previousButtonText = buttonText.textContent;
              }
            }
          }
        }

        if (this.variantIdInput) {
          let variantId = null;
          
          if (variant && variant.id) {
            variantId = variant.id;
          } else if (data && data.variantId) {
            variantId = data.variantId;
          } else {
            const mainProductForm = document.querySelector('.main-product__details form, .product-form form');
            if (mainProductForm) {
              const mainVariantInput = mainProductForm.querySelector('input[name="id"]');
              if (mainVariantInput && mainVariantInput.value) {
                variantId = mainVariantInput.value;
              }
            }
          }
          
          if (variantId) {
            this.variantIdInput.value = variantId;
            this.variantIdInput.disabled = false;
          } else {
            this.variantIdInput.value = '';
            this.variantIdInput.disabled = true;
          }
        }

      }

      updateVariantSelectsFromOptions(selectedOptionValues) {
        this.variantSelects.forEach(select => {
          const optionPosition = select.dataset.optionPosition;
          if (optionPosition && selectedOptionValues[optionPosition - 1]) {
            const optionValue = selectedOptionValues[optionPosition - 1];
            if (select.value !== optionValue) {
              select.value = optionValue;
            }
          }
        });
      }

      updateVariantSelectsFromVariant(variant) {
        this.variantSelects.forEach(select => {
          const optionPosition = select.dataset.optionPosition;
          if (optionPosition && variant.options) {
            const optionValue = variant.options[parseInt(optionPosition) - 1];
            if (optionValue && select.value !== optionValue) {
              select.value = optionValue;
            }
          }
        });
      }

      updateVariantSelects(variant) {
        this.variantSelects.forEach(select => {
          const optionPosition = select.dataset.optionPosition;
          if (optionPosition) {
            const optionValue = variant.options[parseInt(optionPosition) - 1];
            if (optionValue) {
              select.value = optionValue;
            }
          }
        });
      }

      updatePriceDisplay(container, variant) {
        if (!container || !variant) return;

        const priceElements = container.querySelectorAll('.price, .price-item, [class*="price"]');
        
        if (priceElements.length === 0) {
          this.updatePriceContainer(container, variant);
        } else {
          priceElements.forEach(element => {
            this.updatePriceContainer(element, variant);
          });
        }
      }

      updatePriceContainer(container, variant) {
        if (!container || !variant) return;

        const hasValidPrice = variant.price && !isNaN(variant.price) && variant.price > 0;
        const hasValidComparePrice = variant.compare_at_price && !isNaN(variant.compare_at_price) && variant.compare_at_price > 0;

        const regularPrice = container.querySelector('.price__regular .price-item--regular, .price__regular');
        if (regularPrice && hasValidPrice) {
          regularPrice.textContent = this.formatMoney(variant.price);
        }

        const compareAtPrice = container.querySelector('.price__sale .price-item--sale, .price__sale');
        if (compareAtPrice && hasValidComparePrice) {
          compareAtPrice.textContent = this.formatMoney(variant.compare_at_price);
        }

        const mainPrice = container.querySelector('.price-item--regular, .price__regular');
        if (mainPrice && hasValidPrice) {
          mainPrice.textContent = this.formatMoney(variant.price);
        }

        if (!regularPrice && !compareAtPrice && !mainPrice && hasValidPrice) {
          container.textContent = this.formatMoney(variant.price);
        }
      }

      formatMoney(cents) {
        if (!cents || isNaN(cents) || cents <= 0) {
          return '';
        }

        if (typeof window.Shopify?.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents);
        }
        
        const amount = (cents / 100).toFixed(2);
        return `$${amount}`;
      }

      updateMainProductVariant(changedSelect, optionPosition) {
        const selectors = [
          `.variant-picker select[data-option-position="${optionPosition}"]`,
          `.variant-picker input[data-option-position="${optionPosition}"]`,
          `.variant-picker select[name*="options"][data-option-position="${optionPosition}"]`,
          `.variant-picker input[name*="options"][data-option-position="${optionPosition}"]`
        ];
        
        let mainInput = null;
        for (const selector of selectors) {
          mainInput = document.querySelector(selector);
          if (mainInput) break;
        }
        
        if (!mainInput) {
          const optionName = changedSelect.name.replace('options[', '').replace(']', '');
          
          const nameSelectors = [
            `input[name="${optionName}-${optionPosition}"]`,
            `select[name="${optionName}-${optionPosition}"]`,
            `input[name*="${optionName}"]`,
            `select[name*="${optionName}"]`,
            `input[name*="${optionName.split(' ')[0]}"]`,
            `input[type="radio"][name*="${optionName.split(' ')[0]}"]`
          ];
          
          for (const selector of nameSelectors) {
            try {
              mainInput = document.querySelector(selector);
              if (mainInput) break;
            } catch (e) {
            }
          }
          
          if (!mainInput) {
            const allRadios = document.querySelectorAll('input[type="radio"]');
            const radiosByPosition = Array.from(allRadios).filter(radio => {
              const name = radio.name;
              return name.includes(optionName.split(' ')[0]) || name.includes(optionPosition);
            });
            
            if (radiosByPosition.length > 0) {
              mainInput = radiosByPosition[0];
            }
          }
        }
        
        if (mainInput) {
          if (mainInput.type === 'radio') {
            const cleanName = mainInput.name.replace(/\s+/g, ' ').trim();
            const cleanValue = changedSelect.value.replace(/\s+/g, ' ').trim();
            
            let radioInput = null;
            
            try {
              radioInput = document.querySelector(`input[name="${cleanName}"][value="${cleanValue}"]`);
            } catch (e) {
              // Continue to alternative approach
            }
            
            if (!radioInput) {
              const radioGroup = document.querySelectorAll(`input[name="${cleanName}"]`);
              radioGroup.forEach(radio => {
                if (radio.value === cleanValue) {
                  radioInput = radio;
                }
              });
            }
            
            if (!radioInput) {
              const allRadios = document.querySelectorAll(`input[type="radio"][name*="${cleanName.split('-')[0]}"]`);
              allRadios.forEach(radio => {
                if (radio.value === cleanValue) {
                  radioInput = radio;
                }
              });
            }
            
            if (radioInput && !radioInput.checked) {
              radioInput.checked = true;
              radioInput.dispatchEvent(new Event("change", { bubbles: true }));
              return true;
            } else if (!radioInput) {
              return false;
            }
          } else if (mainInput.tagName === 'SELECT') {
            if (mainInput.value !== changedSelect.value) {
              mainInput.value = changedSelect.value;
              mainInput.dispatchEvent(new Event("change", { bubbles: true }));
              return true;
            }
          }
        } else {
          return false;
        }
        
        return true;
      }

      updateMainProductViaAPI(changedSelect, optionPosition) {
        const selectedValues = [];
        this.variantSelects.forEach(select => {
          selectedValues.push(select.value);
        });
        
        const variantPicker = document.querySelector('.variant-picker');
        if (variantPicker) {
          const syntheticEvent = new CustomEvent('variant:change', {
            detail: {
              selectedOptionValues: selectedValues,
              optionPosition: optionPosition,
              value: changedSelect.value
            },
            bubbles: true
          });
          
          variantPicker.dispatchEvent(syntheticEvent);
          return true;
        }
        
        return false;
      }

      syncFromMainInput(mainInput) {
        const optionPosition = mainInput.dataset.optionPosition;
        const stickySelect = this.querySelector(`[data-option-position="${optionPosition}"]`);
        
        if (stickySelect) {
          let valueToSync = null;
          
          if (mainInput.type === 'radio' && mainInput.checked) {
            valueToSync = mainInput.value;
          } else if (mainInput.tagName === 'SELECT') {
            valueToSync = mainInput.value;
          } else if (mainInput.type === 'checkbox' && mainInput.checked) {
            valueToSync = mainInput.value;
          }
          
          if (valueToSync && stickySelect.value !== valueToSync) {
            stickySelect.value = valueToSync;
          }
        }
      }

      syncFromMainSelect(mainSelect) {
        const optionPosition = mainSelect.dataset.optionPosition;
        const stickySelect = this.querySelector(`[data-option-position="${optionPosition}"]`);
        
        if (stickySelect && stickySelect.value !== mainSelect.value) {
          stickySelect.value = mainSelect.value;
        }
      }

      updateStickyBarContent() {
        const currentVariant = this.getCurrentVariantFromSelects();
        if (currentVariant) {
          this.updateFromMainProduct(currentVariant);
        }
      }

      getCurrentVariantFromSelects() {
        return null;
      }

      setStickyBarHeight() {
        if (this.parent) {
          const height = this.parent.offsetHeight;
          document.documentElement.style.setProperty("--sticky-atc-height", `${height}px`);
        }
      }

      attachEventListeners() {
        this.resizeObserver = new ResizeObserver(() => {
          this.setStickyBarHeight();
        });
        this.resizeObserver.observe(this.parent);

        window.addEventListener("resize", () => {
          this.setStickyBarHeight();
        });
      }

      initializeFormHandling() {
        const form = this.querySelector("form");
        if (form) {
          form.addEventListener("submit", (e) => {
            this.handleFormSubmit(e);
          });
        }
      }

      handleFormSubmit(event) {
        const submitButton = this.querySelector(".sticky-atc-bar__submit");
        if (submitButton) {
          submitButton.classList.add("loading");
          submitButton.disabled = true;

          const updateProductFormsCartQty = () => {
            document.querySelectorAll('product-form').forEach((el) => {
              if (typeof el.updateCartQuantity === 'function') el.updateCartQuantity();
            });
          };

          const finish = (type) => {
            submitButton.classList.remove("loading");
            submitButton.disabled = false;
            updateProductFormsCartQty();
            document.dispatchEvent(new CustomEvent(type, { bubbles: true }));
          };

          let unsubscribeCartUpdate = null;
          let unsubscribeCartError = null;

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
              finish('cart:updated');
              unsubscribeCartUpdate?.();
              unsubscribeCartError?.();
            });
            unsubscribeCartError = subscribe(PUB_SUB_EVENTS.cartError, () => {
              finish('cart:error');
              unsubscribeCartUpdate?.();
              unsubscribeCartError?.();
            });
          } else {
            const handleCartUpdate = () => {
              submitButton.classList.remove("loading");
              submitButton.disabled = false;
              updateProductFormsCartQty();
              document.removeEventListener("cart:updated", handleCartUpdate);
              document.removeEventListener("cart:error", handleCartUpdate);
            };
            document.addEventListener("cart:updated", handleCartUpdate);
            document.addEventListener("cart:error", handleCartUpdate);
          }

          setTimeout(() => {
            submitButton.classList.remove("loading");
            submitButton.disabled = false;
            updateProductFormsCartQty();
            unsubscribeCartUpdate?.();
            unsubscribeCartError?.();
          }, 5000);
        }
      }

      cleanup() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }
    }

    customElements.define("sticky-atc-bar", StickyAtcBar);
  }

  function checkStickyBarVisibility() {
    const stickyBar = document.querySelector(".sticky-add-to-cart");
    let productDetails = document.querySelector(".main-product__details");
    
    if (!productDetails) {
      productDetails = document.querySelector(".main-product__info-block");
    }
    if (!productDetails) {
      productDetails = document.querySelector(".main-product");
    }
    
    if (!stickyBar) return;
    
    if (!productDetails) {
      const scrollThreshold = 300;
      
      function handleScroll() {
        const scrolled = window.scrollY;
        
        if (scrolled > scrollThreshold && !stickyBar.classList.contains("js-hidden")) {
          stickyBar.classList.add("atc-visible");
        } else {
          stickyBar.classList.remove("atc-visible");
        }
      }

      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return;
    }

    const productDetailsHeight = productDetails.offsetHeight;
    const scrollThreshold = productDetailsHeight * 0.3;

    function handleScroll() {
      const scrolled = window.scrollY;
      
      if (scrolled > scrollThreshold && !stickyBar.classList.contains("js-hidden")) {
        stickyBar.classList.add("atc-visible");
      } else {
        stickyBar.classList.remove("atc-visible");
      }
    }

    window.addEventListener("scroll", handleScroll);
    
    handleScroll();
  }

  function initCloseButton() {
    const closeButton = document.querySelector(".sticky-atc-bar__close");
    const stickyBar = document.querySelector(".sticky-add-to-cart");
    
    if (!closeButton || !stickyBar) return;

    closeButton.addEventListener("click", () => {
      stickyBar.classList.add("js-hidden");
      stickyBar.classList.remove("atc-visible");
    });

    closeButton.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " " || e.key === "Escape") {
        stickyBar.classList.add("js-hidden");
        stickyBar.classList.remove("atc-visible");
      }
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const stickyBar = document.querySelector(".sticky-add-to-cart");
      if (stickyBar && !stickyBar.classList.contains("js-hidden")) {
        stickyBar.classList.add("js-hidden");
        stickyBar.classList.remove("atc-visible");
      }
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    checkStickyBarVisibility();
    initCloseButton();
  });

  document.addEventListener("shopify:section:load", (event) => {
    if (event.detail.sectionId && event.target.querySelector(".sticky-add-to-cart")) {
      checkStickyBarVisibility();
      initCloseButton();
    }
  });

  setTimeout(() => {
    const stickyBar = document.querySelector(".sticky-add-to-cart");
    if (stickyBar && !stickyBar.classList.contains("atc-visible")) {
      checkStickyBarVisibility();
      initCloseButton();
    }
  }, 1000);

  document.addEventListener("variant:change", (e) => {
    const stickyBar = document.querySelector("sticky-atc-bar");
    if (stickyBar && stickyBar.updateFromMainProduct) {
      stickyBar.updateFromMainProduct(e.detail);
    }
  });

  document.addEventListener("variant:selected", (e) => {
    const stickyBar = document.querySelector("sticky-atc-bar");
    if (stickyBar && stickyBar.updateFromMainProduct) {
      stickyBar.updateFromMainProduct(e.detail);
    }
  });

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const stickyBar = document.querySelector("sticky-atc-bar");
      if (stickyBar && stickyBar.updateFromMainProduct) {
        stickyBar.updateFromMainProduct(data);
      }
    });
  }
})();